import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { Config } from 'datatables.net';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Subject } from 'rxjs';
import { ApiServiceListService } from 'src/app/_services/api/api-service-list.service';
import { TableRequest, ActionType, ITable } from 'src/app/model/table.model';

@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    styleUrl: './user-list.component.css',
    standalone: false
})
export class UserListComponent implements OnInit{
  public breadcrumb: any;
    options = {
      close: false,
      expand: false,
      minimize: false,
      reload: false
    };
    closeResult = '';
  
    constructor(private route: ActivatedRoute, private loader: LoadingBarService, private http: HttpClient, private apiService: ApiServiceListService, private router: Router, private modalService: NgbModal, private toastr: ToastrService) {
    }
    @ViewChild('itemDeleteModal') itemDeleteModal!: any;
    currentModuleName = this.route.snapshot.data['module'];
    columnList = [];
    tableData = [];
    pageInfo: TableRequest = {
      pageSize: 10,
      currentPage: 1,
      totalCount: 0,
      filteredValue: [],
      searchValue: '',
      sortColumn: '',
      sortOrder: 'asc'
    }
    actionItems: ActionType[] = [];
    filterFields = [];
    actionType = ActionType;
  
    pageInfoChange(data) {
      this.pageInfo = data;
      this.getUsersTableData();
    }
  
    ngOnInit() {
      this.getDeliveryAgentFullDetails();
    }
  
  
    moveToAdd() {
      this.router.navigateByUrl('/user-representative/create');
    }
  
    getDeliveryAgentFullDetails() {
      const filterInfo$ = this.apiService.getUsersFilterDetails();
      const getTableData$ = this.apiService.getUsersTableData({ body: this.pageInfo });
  
      // Combine both observables
      forkJoin([filterInfo$, getTableData$]).subscribe(
        {
          next: ([filterInfo, tableData]) => {
            if (filterInfo) {
              this.filterFields = filterInfo.data.filterFields;
              this.actionItems = filterInfo.data.actionItems;
              this.columnList = filterInfo.data.columnList;
            }
            if (tableData) {
              this.tableData = tableData.data.tableData;
              this.pageInfo.totalCount = tableData.data.pageInfo.totalCount;
            }
          },
          error: (error) => {
            console.error('Error:', error);
          }
        }
      );
    }
  
  
    getUsersTableData() {
      let parameter: any = {
        body: this.pageInfo
      }
      this.loader.increment(35);
      this.apiService.getUsersTableData(parameter).subscribe({
        next: (value: ITable) => {
          // Handle emitted values
          if (value.data.tableData) {
            this.tableData = value.data.tableData;
            this.pageInfo.totalCount = value.data.pageInfo.totalCount;
          } else {
            this.tableData = [];
            this.pageInfo.totalCount = 0;
          }
        },
        error: (error: any) => {
          // Handle errors
        },
        complete: () => {
          this.loader.complete();
        }
      });
    }
  
  
    actionEvent(data) {
      if (data.type == this.actionType.UPDATE) {
        this.editItem(data.value._id);
      }
      if (data.type == this.actionType.DELETE) {
        // this.deleteItemCheck(this.itemDeleteModal, data.value._id);
      }
      if (data.type === this.actionType.COUPON) {
        this.couponCodeNavigate(data);
      }
    }
  
    couponCodeNavigate(data) {
      if (data.value.couponId) {
        this.router.navigateByUrl('/coupon/user-rep/' + data.value._id + '/' + data.value.userRepId + '/update/' + data.value.couponId);
      } else {
        this.router.navigateByUrl('/coupon/user-rep/' + data.value._id + '/' + data.value.userRepId + '/create');
      }
    }
  
    editItem(id: string) {
      this.router.navigateByUrl('/user-representative/update/' + id);
    }
  
    deleteItemCheck(itemDelModal: any, id) {
      let self = this;
  
      self.modalService.open(itemDelModal, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', size: 'sm', centered: true }).result.then((result) => {
        console.log("self.selectObj", result);
        if (result == 'Ok click') {
          this.deleteItem(id);
        } else {
          this.closeResult = `Dismissed ${this.getDismissReason(result)}`;
        }
      }, (reason) => {
        console.log("close");
  
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
  
    deleteItem(id) {
      let body: any = {};
      body = { "_id": id }
      this.apiService.deleteProductPromotionAPI(body).subscribe({
        next: (response: any) => {
          console.log(response);
          if (response.success) {
            this.toastr.success(response.message, '', {
              timeOut: 3000,
            });
            this.getUsersTableData();
          } else {
            this.toastr.error(response.message, '', {
              timeOut: 3000,
            });
          }
        },
        error: (error) => {
          this.toastr.error(error.message, '', {
            timeOut: 3000,
          });
        }
      });
    }
  
    private getDismissReason(reason: any): string {
      console.log(reason);
  
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return `with: ${reason}`;
      }
    }
}
